module.exports = __webpack_public_path__ + "img/icon_best-value.9d92174f.svg";